const fontWeightDict: { [nameLoweredConcat: string]: string } = {
  ultrathin: "100",
  extrathin: "150",
  thin: "100",
  hairline: "100",

  extralite: "200",
  ultralite: "200",
  extralight: "200",
  ultralight: "200",

  lite: "300",
  light: "300",
  lt: "300",
  book: "350",

  // normal and not in dict to avoid finding "regular" in variable-fonts (e.g. google fonts)
  // normal: "400",
  // regular: "400",
  thick: "425",
  extrathick: "450",
  dark: "500",
  md: "500",
  medium: "500",
  extradark: "550",
  semibold: "600",
  demibold: "600",
  bold: "700",
  bd: "700",

  xbold: "800",
  xbd: "800",
  extrabold: "800",
  ultrabold: "800",
  heavy: "900",
  black: "900",
  extrablack: "900",
  ultrablack: "999",
  "100": "100",
  "150": "150",
  "200": "200",
  "300": "300",
  "400": "400",
  "425": "425",
  "450": "450",
  "500": "500",
  "550": "550",
  "600": "600",
  "700": "700",
  "800": "800",
  "900": "900",
  "999": "999",
};

const fontStyleDict = {
  italic: "italic",
  oblique: "oblique",
  // normal not in dict to avoid finding weight-normal
};

/**
 * utily function that creates getWeight and getStyle
 * @param styleAndWeight
 * @param fontName
 * @param paramsDict
 * @param defaultParam
 */
function searchParamInFontName(
  styleAndWeight: string,
  fontName: string,
  fontFamily: string,
  isVariableFont: boolean,
  paramsDict: { [name: string]: string },
  defaultParam: string
) {
  const allAvailableParams = Object.keys(paramsDict)
    // sort by param length so it will find "extra bold" before "bold"
    .sort((a, b) => {
      return b.length - a.length;
    });
  const fontNameWithoutFamily = fontName
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]/g, "")
    .replaceAll(fontFamily.toLowerCase().replace(/[^a-zA-Z0-9]/g, ""), "");

  // search in name
  const styleConcatLoweredFromName = fontNameWithoutFamily.replaceAll(" ", "");
  const paramNameFromFontName = allAvailableParams.find((weight) =>
    styleConcatLoweredFromName.includes(weight)
  );
  if (paramNameFromFontName) return paramsDict[paramNameFromFontName];
  // search in style (in some fonts, e.g. Raleway, style is missing)
  const styleConcatLowered = styleAndWeight.toLowerCase().replaceAll(" ", "");
  const paramName = allAvailableParams.find((weight) =>
    styleConcatLowered.includes(weight)
  );

  if (paramName) return paramsDict[paramName];
  return defaultParam;
}

export function getFontWeight(
  styleAndWeight: string,
  fontName: string,
  fontFamily: string,
  isVariableFont: boolean
) {
  return searchParamInFontName(
    styleAndWeight,
    fontName,
    fontFamily,
    isVariableFont,
    fontWeightDict,
    "400"
  );
}
export function getFontStyle(
  styleAndWeight: string,
  fontName: string,
  fontFamily: string,
  isVariableFont: boolean
) {
  return searchParamInFontName(
    styleAndWeight,
    fontName,
    fontFamily,
    isVariableFont,
    fontStyleDict,
    "normal"
  );
}
const templateGenerator = ({
  family,
  style,
  url,
  name,
  isVariableFont,
}: {
  family: string;
  style: string; // actually style and weight in one line
  url: string;
  name: string;
  isVariableFont: boolean;
}) => {
  const weight = getFontWeight(style, name, family, isVariableFont);
  const fontStyle = getFontStyle(style, name, family, isVariableFont);

  return `@font-face {
    font-family: '${family}';
    src: url(${url});
    font-weight: ${weight};
    font-style: ${fontStyle};
  }`;
};
// Deprecated
export const generateFontFace = (
  fonts: {
    family: string;
    style: string;
    url: string;
    name: string;
    isVariableFont: boolean;
  }[]
) => {
  const file = fonts.map((font) => templateGenerator(font)).join("\n");
  return file;
};
